import { ReactElement, useEffect, useState } from "react";

import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

import { slashedYMDFromString } from "helpers/date";
import { convertHomeString, convertPriceString } from "helpers/label";
import { MovementLog } from "models/movementLog";

export interface CountDetailListProps {
  movementLogs: MovementLog[];
}

export const CloseButton = styled.button`
  margin-left: 1em;
`;

export function CountDetailItem({
  id,
  at,
  departureName,
  arrivalName,
  totalFare,
}: MovementLog): ReactElement | null {
  return (
    <div key={id}>
      {slashedYMDFromString(at)} {convertHomeString(departureName)} ⇒{" "}
      {convertHomeString(arrivalName)} {convertPriceString(totalFare)}
    </div>
  );
}

export function CountDetailList({
  movementLogs,
}: CountDetailListProps): ReactElement | null {
  const [visible, setVisible] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      setVisible(visible);
    })();
  }, [visible]);

  const handleVisible = () => {
    setVisible(!visible);
  };
  if (movementLogs.length >= 1) {
    return (
      <>
        <CloseButton onClick={(_event) => handleVisible()} className="icon">
          {visible ? (
            <FontAwesomeIcon icon={faAngleUp} />
          ) : (
            <FontAwesomeIcon icon={faAngleDown} />
          )}
        </CloseButton>
        <section className={`${visible ? "" : "is-hidden"}`}>
          {movementLogs.map((movementLog) => CountDetailItem(movementLog))}
        </section>
      </>
    );
  }
  return null;
}
